import React, { useEffect, useState } from 'react';
import dataProvider from '../lib/dataProvider';

import Paper from '@mui/material/Paper';
import CardContent from '@mui/material/CardContent';

const Video = (props) => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    dataProvider.getList('dashboardVideo', {
      filter: {},
      sort: { field: 'id', order: 'ASC' },
      pagination: { page: 1, perPage: 999 },
    }).then(response => {
      if (response.data) {
        setVideos(response.data);
      }
    });
  }, []);

  return (
    <Paper style={{scroll:'auto'}} >
      <CardContent>
        <h3>Training Videos:</h3>
        {videos.map(v => {
          const videoId = v.vimeo_id || v.video_id || v.id_vimeo || v.id;
          const title = v.title || '';
          return (
            <div key={v.id || videoId} style={{marginBottom:'2em'}}>
              <h2>{title}</h2>
              <iframe
                src={`https://player.vimeo.com/video/${parseInt(videoId, 10)}`}
                width="640"
                height="360"
                frameBorder="0"
                allowFullScreen
                title={title}
              />
            </div>
          );
        })}
        <p>Watch other videos on the <a href="https://vimeo.com/hosteloffice" target="_blank" rel="noreferrer">HostelOffice vimeo-channel</a>.</p>
      </CardContent>
    </Paper>
  )
}

export default Video;
